import script from "./mealsOrderList.vue?vue&type=script&setup=true&lang=js"
export * from "./mealsOrderList.vue?vue&type=script&setup=true&lang=js"

import "./mealsOrderList.vue?vue&type=style&index=0&id=308e1b1e&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308e1b1e"]])

export default __exports__